/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Tab } from '@mui/material';
import styled from '@emotion/styled';
import { useAppSelector } from '../../../../app/hooks';
import { selectIsBoddUser, selectIsQaUser } from '../../auth/authSlice';
import boddVariables from '../../../../variables.module.scss';

export interface BoddOnlyTabProps {
    label: string;
    value: number;
    disabled?: boolean;
    allowQa?: boolean;
}

const BoddOnlyTab = styled((p: BoddOnlyTabProps) => {
    const { allowQa, ...tabProps } = p;
    const isBoddOnlyUser = useAppSelector(selectIsBoddUser);
    const isAllowedQaUser = useAppSelector(selectIsQaUser) && allowQa;
    if (!(isAllowedQaUser || isBoddOnlyUser)) {
        return null;
    }
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Tab disableRipple {...tabProps} sx={{ backgroundColor: `${boddVariables.brandPink}26` }} />
    );
})(() => ({
    textTransform: 'none',
}));

export interface TabPanelProps {
    // eslint-disable-next-line react/require-default-props
    children?: React.ReactNode;
    // eslint-disable-next-line react/require-default-props
    flexLayout?: boolean;
    index: number;
    value: number;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, flexLayout, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            style={flexLayout && value === index ? { display: 'flex', flexDirection: 'column', flex: 1 } : {}}
            {...other}
        >
            {value === index && (
                <Box sx={flexLayout ? { display: 'flex', flexDirection: 'column', flex: 1, py: 1 } : { py: 1 }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

export { BoddOnlyTab, TabPanel };
